/** Join class names, dropping anything falsy. Keeps conditional classes readable at call sites. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
